import { GetterTree } from "vuex";
import { StateInterface } from "../index";
import { UserStateInterface } from "./state";

import MaRefs from "src/modules/ma/classes/ma_refs";
import maObjects from "src/modules/ma/classes/ma_objects";

const getters: GetterTree<UserStateInterface, StateInterface> = {
  isAnonymous(context) {
    return !!(
      !context.ma_session &&
      (!context.id ||
        MaRefs.compareAsStr(context.id, MaRefs.str.objs.anonymousUser))
    );
  },
  checkAccess(context) {
    return (a: any) => {
      const ref = a
        ? typeof a == "string"
          ? a
          : maObjects.ref2str(maObjects.toRef(a))
        : "";
      return !!context.access[ref];
    };
  },
};

export default getters;
